module.exports = __webpack_public_path__ + "static/img/zgsy.591a54d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zgsy.png
// module id = YKRl
// module chunks = 0